module.exports = __webpack_public_path__ + "img/dashboard-date.7c6b4df0.png";